export const environment = {
  production: true,
  title: 'Production Environment Heading',
  apiUrl: 'https://ntrack.nsi.id/pls/',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts